import type React from 'react';
import { useShortcutScope } from '@/components/shortcuts';

type SellerShortcutScopeProps = {
    children: React.ReactNode;
};

/**
 * Pushes the `seller` shortcut scope for as long as the sale screen is
 * mounted; a dialog opened from it pushes its own scope on top, suspending
 * this one until the dialog closes. Kept separate from `Seller.tsx` so that
 * composition point stays hook-free.
 */
export const SellerShortcutScope: React.FC<SellerShortcutScopeProps> = ({
    children,
}) => {
    useShortcutScope('seller');
    return <>{children}</>;
};
